import type { AuthSession } from './auth-session.js';
import { vittoSession } from './vitto-session.js';

/**
 * TASKS-APP-FULL-UI-1 U2b-2 — what the STANDALONE document does with the Vitto identity at load: remember it across reloads (the refresh token
 * already survives them) and bring back what was remembered — but only while a session to go with it exists. An identity with no refresh token
 * is a leftover (the person signed out elsewhere, storage was cleared piecemeal): dropped, so it cannot dress a later password login.
 * A framed document and the product's own login have no remembered identity at all.
 */
export function bootVittoSession(
  kind: 'own' | 'standalone' | 'embedded',
  session: AuthSession,
  storage: Storage | null,
): void {
  if (kind !== 'standalone') return;
  vittoSession.persistIn(storage);
  if (session.store.refresh === null) vittoSession.clear();
  else vittoSession.restore();
}
